/**
 * Returns true when the app is running in Playwright test mode.
 *
 * The `!import.meta.env.PROD` guard ensures Vite dead-code-eliminates
 * every call site in production builds — no test-mode branch ever ships
 * to users regardless of what the runtime environment looks like.
 *
 * Activates on either:
 *   - `VITE_PLAYWRIGHT_TEST_MODE=true` (set by run-e2e-with-test-db.sh
 *     when booting the dev server for E2E), or
 *   - `localStorage.test_mode` / `localStorage.playwright_test_mode`
 *     === 'true' (manual override for a dev poking at the test-mode
 *     branches in their browser without spinning up the full runner).
 */
export function isPlaywrightTestMode(): boolean {
  if (import.meta.env.PROD) return false;
  if (import.meta.env.VITE_PLAYWRIGHT_TEST_MODE === 'true') return true;
  if (typeof window === 'undefined') return false;
  return (
    window.localStorage.getItem('test_mode') === 'true' ||
    window.localStorage.getItem('playwright_test_mode') === 'true'
  );
}
